import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Tooltip from '../../../../../common/tooltip';
import CheckboxSwitch from '../../../../../common/checkboxSwitch';
import Select from '../../../../../common/select';
import ChangeFulfillmentConfirmation from '../ChangeFulfillmentConfirmation';
import Icon, { GLYPHS } from '../../../../../common/icon';

const ShopifySettingsForm =
  ({ connectedTo, confirmationIsOn, confirmationOff, handleSubmit, locations, remoteLocations, shopifySettings, submit }) => {
    const connectedAccountName = shopifySettings.shopIdentifier;
    const canDisplayConnectionCards = !!(connectedTo && connectedAccountName);

    return (
      <React.Fragment>
        <div display-if={canDisplayConnectionCards} className="shopify-settings-page__body__state">
          <div className="shopify-state-card">
            <strong>Status</strong>
            <div>
              <Icon glyph={GLYPHS.checkMarkBlue} className="o-icon--micro" />
              {connectedTo}
            </div>
          </div>
          <div className="shopify-state-card">
            <strong>Connected account name</strong>
            <div>
              <Icon glyph={GLYPHS.checkMarkBlue} className="o-icon--micro" />
              {connectedAccountName}
            </div>
          </div>
        </div>
        <form
          className="shopify-settings-form"
          data-automation-id="shopify-settings-form"
          id="shopify-settings-form"
          onSubmit={handleSubmit}
        >
          <div className="u-mt- u-mb- o-flexbox o-flexbox--justify-start o-flexbox--content-align-center">
            <div className="shopify-settings-form__text">
            Fulfillment location
            <Tooltip
              className="c-info-tooltip-new--small"
              text="These are the locations in Squire and Shopify where your e-commerce orders are fulfilled. Selecting these locations will determine where your inventories will sync."
            />
            </div>
          </div>
          <label htmlFor="locationId">Squire inventory ADDRESS</label>
          <Select className="c-select" name="locationId" options={locations} />
          <div className="u-mt-">
            <label htmlFor="remoteLocationId">Shopify Inventory ADDRESS</label>
            <Select className="c-select u-mb-" name="remoteLocationId" options={remoteLocations} />
          </div>
          <div className="u-mt- u-mb o-flexbox o-flexbox--justify-space-between o-flexbox--content-align-center">
            <div className="shopify-settings-form__text">
            Reconcile inventory from
            <Tooltip
              className="c-info-tooltip-new--small"
              text="The inventory source selected here will be where Squire sources a product’s initial inventory after being matched in both platforms. Periodic reconciliation will also draw from this source if any information mismatches."
            />
            </div>
            <div className="shopify-settings-form__radio">
              <label className="c-radio" htmlFor="primarySourceSquire">
                <Field
                  id="primarySourceSquire"
                  name="primarySource"
                  component="input"
                  type="radio"
                  className="c-radio__input"
                  value="squire"
                />
                <span className="c-radio__trigger" />
                <span className="c-radio__label">Squire</span>
              </label>
              <label className="c-radio" htmlFor="primarySourceShopify">
                <Field
                  id="primarySourceShopify"
                  name="primarySource"
                  component="input"
                  type="radio"
                  className="c-radio__input"
                  value="vendor"
                />
                <span className="c-radio__trigger" />
                <span className="c-radio__label">Shopify</span>
              </label>
            </div>
          </div>
          <div className="u-mt u-mb o-flexbox o-flexbox--justify-space-between o-flexbox--content-align-center">
            <div className="shopify-settings-form__text">
            Price sync
            <Tooltip
              className="c-info-tooltip-new--small"
              text="Enabling price syncing will allow Commander to push price updates to Shopify. This can be done in the input E-commerce Price in Product Details."
            />
            </div>
            <div className="shopify-settings-form__checkbox">
              <CheckboxSwitch
                name="enablePriceSync"
                id="enablePriceSync"
              />
            Active
          </div>
          </div>
          <ChangeFulfillmentConfirmation
            connectedProductsCount={10}
            onSubmit={submit}
            openedIsOn={confirmationIsOn}
            openedOff={confirmationOff}
          />
        </form>
      </React.Fragment>
    );
  };

ShopifySettingsForm.propTypes = {
  connectedTo: PropTypes.string,
  confirmationIsOn: PropTypes.bool.isRequired,
  confirmationOff: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  remoteLocations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  shopifySettings: PropTypes.shape({}).isRequired,
  submit: PropTypes.func.isRequired,
};

ShopifySettingsForm.defaultProps = {
  connectedTo: undefined,
  showHeader: false,
};

export default ShopifySettingsForm;
